import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import SnackbarNotification from "../../utils/SnackbarNotification";
import dayjs from "dayjs";
import { FallingLines } from "react-loader-spinner";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import user1 from "../../images/ic_no_person_photo.svg";
import { FaSearch } from "react-icons/fa";
import { HiArrowDownTray } from "react-icons/hi2";

const EmployeeVisaIDExpiryReport = () => {
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmpID, setSelectedEmpID] = useState("");
  const [records, setRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [searchdata, setSearchData] = useState("");
  const [payrollData, setPayrollData] = useState([]);
  const [paySlipData, setPaySlipData] = useState(null);
  const [Open, setOpen] = useState(false);
  const [showPayslip, setShowPayslip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [payslipStartDate, setPayslipStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [payslipEndDate, setPayslipEndDate] = useState(
    dayjs().format("YYYY-MM-DD"),
  );
  const [branchListFromAPI, setBranchListFromAPI] = useState([]);
  const [branch, setBranch] = useState("-");
  const [deptListFromAPI, setDeptListFromAPI] = useState([]);
  const [dept, setDept] = useState("-");
  const [gradeListFromAPI, setGradeListFromAPI] = useState([]);
  const [grade, setGrade] = useState("-");
  const [loader, setLoader] = useState(true);
  const [selectedDocType, setSelectedDocType] = useState("All");

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    getBranchList(companyCode);
    getDeptList(companyCode);
    getData();
  }, []);

  // ✅ Filter records whenever search or records change
  useEffect(() => {
    if (records.length > 0) {
      filterRecords();
    } else {
      setFilteredRecords(records);
    }
  }, [searchdata, selectedDocType, records]);

  const getBranchList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setBranchListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      console.log("dept newArray", newArray);
      setDeptListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getGradeList = async (companyCode) => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );
      setGradeListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const callPaySlipAPI = async (empID) => {
    console.log("payslip empId", empID);
    setIsLoading(true);
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const response = await axios.get(
        `${base_url}/api/Payslip/${companyCode}/${payslipStartDate}/${payslipEndDate}/${empID}`,
      );

      if (response.status === 200) {
        showSnackbar("success", "Payslip generated successfully");
        setShowPayslip(true);
      } else {
        showSnackbar("error", "Failed to generate payslip.");
      }
    } catch (error) {
      showSnackbar("error", "An error occurred while payslip.");
    } finally {
      setIsLoading(false);
    }
  };

  const resetPayrollFilters = () => {
    setBranch("-");
    setDept("-");
    setGrade("-");
    setSearchData("");
    setFilteredRecords(records);
  };

  const getData = async () => {
    setLoader(true);
    try {
      const today = dayjs().format("YYYY-MM-DD");
      const response = await axios.get(
        `${base_url}/api/CRMHrReports/${companyCode}/EXPIRYREPORT/-/-/-/-/-/-/2024-01-11/${today}`,
      );
      const data = response.data;
      console.log("Data Employee List:", data);
      setRecords(data);
      setFilteredRecords(data); // ✅ Initialize filtered records
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user1;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  // ✅ Search filter function
  // const filterRecords = () => {
  //   if (!searchdata.trim()) {
  //     setFilteredRecords(records);
  //     return;
  //   }

  //   const searchTerm = searchdata.toLowerCase().trim();

  //   const filtered = records.filter((record) => {
  //     // Get all searchable fields
  //     const docType = record?.DocType || "";
  //     const refNo = record?.RefNo || "";
  //     const name = record?.Name || "";
  //     const jobTitle = record?.JobTitle || "";
  //     const docNo = record?.DocNo || "";
  //     const status = record?.Status || "";

  //     // Check if any field matches the search term
  //     return (
  //       docType.toLowerCase().includes(searchTerm) ||
  //       refNo.toString().toLowerCase().includes(searchTerm) ||
  //       name.toLowerCase().includes(searchTerm) ||
  //       jobTitle.toLowerCase().includes(searchTerm) ||
  //       docNo.toString().toLowerCase().includes(searchTerm) ||
  //       status.toLowerCase().includes(searchTerm)
  //     );
  //   });
  //   setFilteredRecords(filtered);
  // };

  const filterRecords = () => {
    let filtered = [...records];

    // Search Filter
    if (searchdata.trim()) {
      const searchTerm = searchdata.toLowerCase().trim();

      filtered = filtered.filter((record) => {
        return (
          record?.DocType?.toLowerCase().includes(searchTerm) ||
          record?.RefNo?.toString()?.toLowerCase().includes(searchTerm) ||
          record?.Name?.toLowerCase().includes(searchTerm) ||
          record?.JobTitle?.toLowerCase().includes(searchTerm) ||
          record?.DocNo?.toString()?.toLowerCase().includes(searchTerm) ||
          record?.Status?.toLowerCase().includes(searchTerm)
        );
      });
    }

    // Document Type Filter
    if (selectedDocType !== "All") {
      filtered = filtered.filter(
        (record) => record?.DocType === selectedDocType,
      );
    }

    setFilteredRecords(filtered);
  };

  const documentTypes = [
    "All",
    ...new Set(
      records
        ?.map((item) => item?.DocType)
        ?.filter((item) => item && item.trim() !== ""),
    ),
  ];

  console.log("Selected Employee:", selectedEmp);

  const groupedRecords = filteredRecords.reduce((acc, item) => {
    const docType = item.DocType || "Unknown";

    if (!acc[docType]) {
      acc[docType] = [];
    }

    acc[docType].push(item);

    return acc;
  }, {});

  const handleExport = () => {
    const columns = [
      { field: "SL NO", headerName: "SL NO" },
      { field: "DocType", headerName: "Document Type" },
      { field: "Name", headerName: "NAME" },
      { field: "RefNo", headerName: "REF NO" },
      { field: "JobTitle", headerName: "JOB TITLE" },
      { field: "DocNo", headerName: "DOCUMENT NO" },
      { field: "ExpiryDate", headerName: "EXPIRY DATE" },
      { field: "Days_of_Exp", headerName: "DAYS LEFT" },
      { field: "Status", headerName: "STATUS" },
    ];

    exportToCSV(columns, records, "Expiry_Documents_Report");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    const headerRow = columns.map((col) => col.headerName);

    const dataRows = exportData.map((row, index) =>
      columns.map((col) => {
        if (col.field === "SL NO") return index + 1;

        let value = row[col.field] ?? "";

        if (col.field === "ExpiryDate" && value) {
          value = dayjs(value).format("DD-MM-YYYY");
          console.log("Value :", value);
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-4">
        <div className="flex justify-left items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              {/* EMPLOYEE VISA / ID EXPIRY */}
              EXPIRY DOCUMENTS
            </span>
          </h6>
        </div>

        {/* ✅ Search Bar */}
        <div className="flex justify-center items-center gap-4">
          <div>
            <label className="block text-xs text-gray-600 mb-1">Search</label>

            <div className="bg-white mr-8 w-72 flex items-center gap-2 p-2 border border-gray-700 rounded-md transition-all duration-200 focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200" />
              <input
                type="text"
                placeholder="Search by Doc Type, Emp ID, Name, Job Title, Doc No, Status..."
                value={searchdata}
                onChange={(e) => setSearchData(e.target.value)}
                className="w-full outline-none text-sm text-gray-700 placeholder-gray-400"
              />
              {searchdata && (
                <button
                  onClick={() => setSearchData("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div>
          </div>
          {searchdata && filteredRecords.length > 0 && (
            <span className="text-xs text-gray-500">
              Found {filteredRecords.length} result
              {filteredRecords.length !== 1 ? "s" : ""}
            </span>
          )}
          {searchdata && filteredRecords.length === 0 && (
            <span className="text-xs text-red-500">
              No matching records found
            </span>
          )}

          <div>
            <label className="block text-xs text-gray-600 mb-1">Filter</label>
            <select
              value={selectedDocType}
              onChange={(e) => setSelectedDocType(e.target.value)}
              className="h-[42px] min-w-[180px] border border-gray-700 rounded-md px-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#2663EB]/20 mr-4"
            >
              {documentTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <button
            disabled={!records.length}
            onClick={handleExport}
            className={`mt-3 mr-3 flex items-center gap-2 px-3 py-2 text-xs rounded-md text-white transition-all duration-200 shadow-sm
                          ${
                            !records.length
                              ? "bg-gray-300 cursor-not-allowed"
                              : "bg-emerald-600 hover:bg-emerald-700"
                          }
                          `}
          >
            <HiArrowDownTray className="text-sm" />
            Export Expiry Documents
          </button>
        </div>

        {/* Optional: Filter buttons - you can uncomment if needed */}
        {/* <div className="flex justify-center items-end gap-4">
          <div className="">
            <label className="block text-sm text-gray-600 ">Branch</label>
            <select
              value={branch || "-"}
              onChange={(e) => setBranch(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>
              {branchListFromAPI?.map((b) => (
                <option key={b.DEPTNO} value={b}>
                  {b}
                </option>
              ))}
            </select>
          </div>

          <div className="">
            <label className="block text-sm text-gray-600 mb-1">
              Department
            </label>
            <select
              value={dept || "-"}
              onChange={(e) => setDept(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>
              {deptListFromAPI?.map((d, index) => (
                <option key={index} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={() => resetPayrollFilters()}
            className="btn btn-sm text-sm"
            style={{ backgroundColor: "#1DC7AD", color: "#ffffff" }}
          >
            Reset Filters
          </button>
        </div> */}
      </div>

      <div className="overflow-auto max-w-85 scrollbar-none rounded-md">
        {loader ? (
          <div className="flex flex-col items-center justify-center py-10 text-gray-500">
            <FallingLines />
            <p className="mt-3 text-sm">Please wait, loading data...</p>
          </div>
        ) : filteredRecords.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 text-gray-400">
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
              <p className="text-sm font-medium">
                {searchdata ? "No matching records found" : "No records found"}
              </p>
            </div>
            <p className="text-xs mt-1">
              {searchdata
                ? "Try adjusting your search terms"
                : "No data available"}
            </p>
          </div>
        ) : (
          <div className="max-h-[70vh] overflow-auto scrollbar-none">

          <table className="shadow-sm min-w-full rounded-sm border border-[gray-300] text-xs">
            <thead className="sticky top-0 z-20">
              <tr className="bg-[#2663EB] text-white">
                {/* <th className="px-2 py-1 font-normal">Sl No</th> */}
                <th className="px-2 py-1 font-normal">Document Type</th>
                <th className="px-2 py-1 font-normal">Ref No (Emp ID)</th>
                <th className="px-2 py-1 font-normal">Name</th>
                <th className="px-2 py-1 font-normal">Job Title</th>
                <th className="px-2 py-1 font-normal">Document No</th>
                <th className="px-2 py-1 font-normal">Expiry Date</th>
                <th className="px-2 py-1 font-normal">Days Left</th>
                <th className="px-2 py-1 font-normal">Status</th>
              </tr>
            </thead>

            <tbody className="text-sm text-gray-700">
              {Object.entries(groupedRecords).map(([docType, records]) =>
                records.map((d, index) => (
                  <tr key={`${docType}-${index}`}>
                    {index === 0 && (
                      <td
                        rowSpan={records.length}
                        className="px-2 py-2 border font-semibold bg-gray-50 align-top"
                      >
                        {docType}
                        <span className="text-xs text-gray-500 ml-2">
                          ({records.length})
                        </span>
                      </td>
                    )}

                    <td className="px-2 py-2 border">{d?.RefNo || "-"}</td>
                    <td className="px-2 py-2 border">{d?.Name || "-"}</td>
                    <td className="px-2 py-2 border">{d?.JobTitle || "-"}</td>
                    <td className="px-2 py-2 border">{d?.DocNo || "-"}</td>

                    <td className="px-2 py-2 border">
                      {d?.ExpiryDate
                        ? dayjs(d.ExpiryDate).format("DD-MMM-YYYY")
                        : "-"}
                    </td>

                    <td className="px-2 py-2 border">
                      {d?.Days_of_Exp ?? "-"}
                    </td>

                    <td
                      className={`px-2 py-2 border font-medium ${
                        d?.Status === "EXPIRED"
                          ? "text-red-600"
                          : d?.Status === "EXPIRING"
                            ? "text-yellow-600"
                            : "text-green-600"
                      }`}
                    >
                      {d?.Status}
                    </td>
                  </tr>
                )),
              )}
            </tbody>
          </table>
          </div>

        )}
        <SnackbarNotification
          open={snackbar.open}
          severity={snackbar.severity}
          message={snackbar.message}
          onClose={handleClose}
        />
      </div>

      {showPayslip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
            <button
              onClick={() => setShowPayslip(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
            >
              &times;
            </button>
            <h2 className="text-lg font-semibold mb-4">Payslip</h2>
            <div className="text-sm space-y-2">
              <p>
                <strong>Name:</strong> {payrollData.name}
              </p>
              <p>
                <strong>Net Pay:</strong> {payrollData.netPay}
              </p>
              <p>
                <strong>Total Wage:</strong> {payrollData.totalWage}
              </p>
              <button onClick={callPaySlipAPI}>Generate Payslip</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeVisaIDExpiryReport;
